import { CButton, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormLabel, CCallout, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CCardBody } from '@coreui/react'
// import { CNav,CNavItem,CNavLink,CTabContent,CTabPane } from "@coreui/react";
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars'

import SchedulerRightPanel from '../../components/shared/SchedulerRightPanel'
import MenuList from '../../components/shared/ReactSelectWrapper'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import { ButtonComponent, CheckBoxComponent } from '@syncfusion/ej2-react-buttons'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { ToolbarComponent, ItemsDirective, ItemDirective, ContextMenuComponent, AppBarComponent } from '@syncfusion/ej2-react-navigations'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import SavePatients from '../../services/general/savePatientinformation.api'
import CustomDropDown from '../../components/shared/CustomDropdown.jsx'
import React, { useEffect, useState, useRef, useReducer } from 'react'
import FacilityTypeFn from '../../services/general/modifyFacilityType.api'
import ModifyAppointment from '../../services/general/modifyAppointments.api'
import AddAppointments from './AddAppointments'
import { CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns'
import Select from 'react-select'
import { extend, removeClass, remove, addClass, Internationalization, isNullOrUndefined, Browser, closest } from '@syncfusion/ej2-base'
import SaveKareo from '../../services/general/syncProviderKareo.api'
import syncServiceLocationFromKareo from '../../services/general/syncServiceLocation.api'
import allAppointmentsFn from '../../services/general/getAppointments.api'
import { ScheduleComponent, ViewsDirective, ViewDirective, Inject, Week, Agenda, ResourcesDirective, ResourceDirective, Resize, DragAndDrop, TimelineMonth, Month } from '@syncfusion/ej2-react-schedule'
import { Button } from 'antd'
import LoadingOverlay from 'react-loading-overlay'
import './Scheduler.css'
import GetPatientsData from '../../services/general/getPatientsData.api.js'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import CustomDatePicker from '../../components/shared/CustomDatePicker'
import ManualScheduling from './ManualScheduling'
import AutoScheduling from './AutoScheduling'
import { AlignLeft, Calendar, CalendarPlus, CirclePlus, Filter } from 'lucide-react'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import Facility from './Facility'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'

import SchedulePatient from './SchedulePatient'
import { itemIDProperty } from '@syncfusion/ej2-documenteditor'
import { getAllAppointments, getAllAppointmentsDetails, getScheduledAppointment } from '../../components/shared/appointmentFilterData'

const SchedulereMulti = () => {
  const [providers, setProviders] = useState([])
  const [allAppointments, setAllAppointments] = useState([])
  const [patientData, setPatientData] = useState([])
  const [insurance, setInsurance] = useState([])
  const [testoptions, setTestoptions] = useState([])
  const [filterService, setFilterService] = useState()
  const [filterProvider, setFilterProvider] = useState()
  const [visible, setVisible] = useState(false)
  const [manualVisible, setManualVisible] = useState(false)
  const [schedulePatient, setSchedulePatient] = useState(null)
  const [notSchedule, setNotSchedule] = useState(null)
  const [patientDate, setPatientDate] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  let timeBtn = useRef(null)
  const [loader, setLoader] = useState(true)
  const [daysMap, setDaysMap] = useState({})

  const [facilities, setFacilities] = useState([])
  const [locations, setLocations] = useState([])

  const [facilityData, setFacilityData] = useState([])

  const [allEvents, setAllEvents] = useState([])
  const [checkedPatients, setCheckedPatients] = useState([])
  const [activeItemKey, setActiveItemKey] = useState(null)
  const [Manual, setManual] = useState([])
  const [callManual, setCallManual] = useState(false)
  const [appointments, setAppointments] = useState([])
  const [allAppointment, setAllAppointment] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [filterData, setFilterData] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    status: null,
    provider: null,
    facility: null,
    date: null,
  })
  const [eventWithoutFilter, setEventWithoutFilter] = useState([])

  const handleAccordionToggle = (itemKey) => {
    setActiveItemKey((prevKey) => (prevKey === itemKey ? null : itemKey))
  }

  // const getAppointmentData = async () => {
  //   setIsPageLoading(true)
  //   try {

  //     let data = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
  //     data = JSON.parse(data.d)?.Data || [];

  //     if (data) {
  //       data = data?.map((item) => {
  //         return {
  //           Id: item.Id,
  //           Data: JSON.parse(item?.JsonData)
  //         }
  //       })

  //     }

  //     console.log("parse data===============>", data)
  //     setAllAppointment(data)
  //     setAppointments(data[0]?.Data)
  //     return data[0]?.Data || []
  //   } catch (error) {
  //     console.log(error)
  //   } finally {
  //     setIsPageLoading(false);
  //   }
  // };

  // const getAppointmentData = async () => {
  //   setIsPageLoading(true)
  //   try {
  //     const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
  //     const rawData = JSON.parse(result.d)?.Data || []

  //     let structuredData = []

  //     rawData.forEach((item) => {
  //       let parsedList = JSON.parse(item?.JsonData)
  //       if (Array.isArray(parsedList)) {
  //         parsedList.forEach((parsedItem) => {
  //           const patientID = parsedItem?.patientID
  //           const appointmentDetails = parsedItem?.appointmentDetails || []

  //           const formattedAppointments = appointmentDetails.map((appointment) => {
  //             const data = appointment?.data || {}
  //             const current = appointment?.current || {
  //               Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
  //               Provider: { value: '', label: data?.ProviderName || 'Unknown' },
  //               Facility: { value: '', label: data?.Facility || 'Unknown' },
  //               Insurance: data?.Insurance || {},
  //               otherDetails: data?.otherDetails || {},
  //             }

  //             return { data, current }
  //           })

  //           structuredData.push({
  //             patientID,
  //             appointmentDetails: formattedAppointments,
  //           })
  //         })
  //       } else {
  //         console.warn('Unexpected non-array parsed data:', parsedList)
  //       }
  //     })

  //     // Save structured data

  //     console.log('appointment data===> ', structuredData)

  //     setAllAppointment(structuredData)

  //     // Optional: Flatten for scheduler view
  //     let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
  //     //  flatAppointments = flatAppointments.filter((item) => item.data.Status === 'Scheduled')
  //     setAppointments(flatAppointments)

  //     return flatAppointments
  //   } catch (error) {
  //     console.log('Error in getAppointmentData', error)
  //   } finally {
  //     setIsPageLoading(false)
  //   }
  // }

  const handleAllAppointmentsData = async (type, byDate) => {
    const appointmentData = await getAllAppointments(type, byDate)
    const appointmentDetails = await getAllAppointmentsDetails(type, byDate)
    const scheduleAppointment = await getScheduledAppointment(type, byDate)
    setAllAppointment(appointmentData)
    setAppointments(appointmentDetails)
    // setOnlyScheduled(scheduleAppointment)
  }

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      await handleAllAppointmentsData('GET')
      const flatAppointments = await getAllAppointmentsDetails('GET')
      console.log('falappointment', flatAppointments)

      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  // const handleSubmit = async (updateData) => {
  //   try {
  //     setIsPageLoading(true)
  //     console.log(" appoinments", appointments, updateData, allAppointment[0]?.Id)
  //     await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify([]), allAppointment[0]?.Id);
  //     getAppointmentData()
  //     toast.success('Saved  Successfully', toastConfig)
  //   } catch (error) {
  //     toast.error('Failed to save', toastConfig)
  //   } finally {
  //     setIsPageLoading(false)
  //   }
  // }

  const handleSubmit = async (updateData) => {
    try {
      setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData();
      getData()
      toast.success('Saved Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  let liveTimeInterval

  const todayDate = new Date()

  useEffect(() => {
    // getAppointmentData()
    const getAllData = async () => {
      const users = await getData()
    }

    getAllData()

    return () => {
      if (liveTimeInterval) {
        clearInterval(liveTimeInterval)
      }
    }
  }, [])

  // const filterAppointments = (provider, service) => {
  //     console.log("procider  all data",provider ,service)
  //     const providerID = provider?.value;
  //     const serviceID = service?.value;
  //     let filterAppointments = eventWithoutFilter.filter((item) => item.Status === "Scheduled" || item.Status === "Rescheduled")

  //     if (provider.label !== 'All-Providers') {
  //         filterAppointments = filterAppointments.filter((item) => item.ProviderName === provider.label)
  //     }

  //     console.log("appointment data ", filterAppointments, allEvents);

  //     console.log("filter appointment ", provider, service)
  //     setAllEvents(filterAppointments)

  // }

  const filterAppointments = (provider, service) => {
    const providerID = provider?.value
    const serviceID = service?.value

    let filteredAppointments = eventWithoutFilter.filter((item) => item.Status === 'Scheduled' || item.Status === 'Rescheduled')

    if (provider?.label === 'All-Providers') {
      if (service?.value) {
        filteredAppointments = filteredAppointments.filter((item) => item.Facility === service.label)
        setAllEvents(filteredAppointments)
      }
      setAllEvents(filteredAppointments)
    } else if (provider?.label) {
      if (provider?.value) {
        filteredAppointments = filteredAppointments.filter((item) => item.ProviderName === provider.label)
      }

      if (service?.value) {
        filteredAppointments = filteredAppointments.filter((item) => item.Facility === service.label)
      }

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      // filteredAppointments = filteredAppointments.filter((item) => {
      //     const startDate = new Date(item.StartTime);
      //     startDate.setHours(0, 0, 0, 0);
      //     return startDate.getTime() === today.getTime();
      // });

      setAllEvents(filteredAppointments)
    } else if (service?.value) {
      filteredAppointments = filteredAppointments.filter((item) => item.Facility === service.label)
      setAllEvents(filteredAppointments)
    }

    // Filter by today's date
  }

  const getAllProviderDetails = async (obj) => {
    const provider = {
      ID: obj.ID,
    }
    let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))
    let insuranceData = JSON.parse(providerData.d)?.Insurance
    let facilityData = JSON.parse(providerData.d)?.Facility
    // setselectProviderInsurances(insuranceData)
    // setselectProviderFacilities(facilityData)

    obj['Insurances'] = insuranceData
    obj['Facilities'] = facilityData

    return obj
  }

  const getAppointments = async () => {
    let temp = await allAppointmentsFn('GET ALL', '')
    let data = JSON.parse(temp.d)
    setAllAppointments(data.Data)
    return data.Data
  }

  const getInsurance = async () => {
    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data
    setInsurance(insurance)
    return insuranceData
  }

  const getPatients = async () => {
    let patientData = await SavePatients('GetAll', '', '', '')
    patientData = JSON.parse(patientData.d)
    let patientList = patientData.Data
    // for (let i = 0; i < patientList.length; i++) {
    //     let insurance = await SavePatients("SelectInsurance", "", "", "", patientList[i].PatientID, "")
    //     patientList[i]["Insurance"] = JSON.parse(insurance.d).Data

    // }
    setPatientData(patientList)

    // let a = data.Data.map(obj=> {
    //     let temp = { value: obj["PatientID"], label: obj["FirstName"] + " " + obj["LastName"] }
    //     return temp
    // })
    // setTestoptions(a)
    return patientList
  }

  const getFacilities = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)
    const formattedData = data.Data.map((facility) => ({
      value: facility.ID,
      label: facility.Name,
    }))
    setFacilities(formattedData)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })

    //  console.log(facilities)
    //  const daysMap = {};

    // // Iterate through the facilities array
    // facilities.forEach(facility => {
    //     // Split the Days string into an array of days
    //     const daysArray = facility.Days.split(',');

    //     // For each day in the daysArray, add the facility to the corresponding entry in the map
    //     daysArray.forEach(day => {
    //         if (!daysMap[day]) {
    //             daysMap[day] = [];
    //         }
    //         daysMap[day].push(facility);
    //     });
    // });

    // setFacilityMap(daysMap)

    setLocations(facilities)
    return data.Data
  }
  const getProviders = async () => {
    let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
    let data = JSON.parse(providerData.d)
    providerData = data.Data
    let newProviders = []
    for (let i = 0; i < providerData.length; i++) {
      let c = await getAllProviderDetails(providerData[i])
      newProviders.push(c)
    }
    setProviders(newProviders)
    const daysMap = {}

    // Iterate through the providers array
    newProviders.forEach((provider) => {
      // Iterate through each facility of the provider
      provider.Facilities.forEach((facility) => {
        // Split the Days string into an array of days
        const daysArray = facility.Days.split(',')

        // For each day in the daysArray, add the provider to the corresponding entry in the map
        daysArray.forEach((day) => {
          day = day.trim()
          if (!daysMap[day]) {
            daysMap[day] = []
          }

          // Find if the provider already exists in the day's scheduler
          let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)
          if (!providerEntry) {
            // Add the provider if not already in the scheduler for that day
            providerEntry = {
              ID: provider.ID,
              Name: provider.Name,
              Gender: provider.Gender,
              DOB: provider.DOB,
              Address: provider.Address,
              AddressDetails: provider.AddressDetails,
              Lat: provider.Lat,
              Lng: provider.Lng,
              Insurances: provider.Insurances,
              Facilities: [],
            }
            daysMap[day].push(providerEntry)
          }

          // Add the facility to the provider's list of facilities
          providerEntry.Facilities.push(facility)
        })
      })
    })
    setDaysMap(daysMap)
    return newProviders
  }

  // const getData = async () => {
  //   setLoader(true)

  //   const currentAppointment = await getAppointmentData()
  //   const providersData = await getProviders();
  //   const locationData = await getFacilities();
  //   const appointmentData = await getAppointments();
  //   const patientData = await getPatients();

  //   const facilityType = generateFacilityType(locationData)
  //   generateAllEvents(currentAppointment)

  //   console.log("current appointment data", currentAppointment)
  //   let filterSchedule =   currentAppointment?.map(appointment => {
  //     let patientDetails = appointment.current.Patient;

  //     return patientDetails
  //   })
  //   console.log(" filter schedule data ", filterSchedule, currentAppointment, facilityType)
  //   let removeDuplicateFilters = filterSchedule?.filter((patient, index, self) => (
  //     index === self.findIndex(p => p?.value === patient?.value)
  //   ))
  //   let patientID = removeDuplicateFilters?.map((item) => item?.value)
  //   let notSchedule = patientData?.filter((item) => !patientID?.includes(item?.PatientID))
  //   setSchedulePatient(removeDuplicateFilters);
  //   setNotSchedule(notSchedule);
  //   setFilterData(notSchedule)
  //   setLoader(false)
  // }

  const getData = async () => {
    setLoader(true)

    const currentAppointment = await getAppointmentData()
    const providersData = await getProviders()
    const locationData = await getFacilities()
    // const appointmentData = await getAppointments();
    const patientData = await getPatients()

    const facilityType = generateFacilityType(locationData)

    generateAllEvents(currentAppointment)

    let filterAppointments = currentAppointment.filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
    let ScheduledPatient = filterAppointments.map((item) => item.data.PatientID)

    const scheduledPatients = currentAppointment
      .map((group) => {
        const patientInfo = group.appointmentDetails?.find((item) => item?.current?.Patient)?.current?.Patient
        return patientInfo || null
      })
      .filter(Boolean)

    const uniqueScheduledPatients = scheduledPatients.filter((patient, index, self) => index === self.findIndex((p) => p?.value === patient?.value))

    const scheduledIDs = uniqueScheduledPatients.map((p) => p.value)
    let notSchedule = patientData?.filter((item) => !scheduledIDs.includes(item?.PatientID))
    notSchedule = patientData?.filter((item) => !ScheduledPatient.includes(item?.PatientID))

    setSchedulePatient(uniqueScheduledPatients)
    setNotSchedule(notSchedule)
    setFilterData(notSchedule)
    setLoader(false)
  }

  const generateFacilityType = (locations) => {
    let facilityType = []
    let facilities = []
    let colors = ['#ffaa00', '#f8a398', '#7499e1', '#FFFF00', '#0000FF']
    let count = 1
    locations.map((obj) => {
      if (!facilities.includes(obj.FacilityType)) {
        let name = obj.FacilityType
        let id = count
        facilityType.push({ TypeName: name, TypeID: id, Color: colors[count - 1] })
        count = count + 1
        facilities.push(name)
      }
    })
    setFacilityData(facilityType)
    return facilityType
  }

  let scheduleObj = useRef(null)
  useEffect(() => {
    scheduleObj.current.group.resources = []
  }, [])

  console.log('grouped data ', scheduleObj)
  const convertDate = (inputDateString) => {
    const [datePart, timePart] = inputDateString.split(' ')

    const [month, day, year] = datePart.split('/')

    if (inputDateString.includes(' ')) {
      const [hours, minutes, seconds] = timePart.split(':')
      const dateObject = new Date(`${year}-${month}-${day}T${hours}:${minutes}`)
      return dateObject
    } else {
      const dateObject = new Date(`${year}-${month}-${day}T00:00:00`)
      return dateObject
    }
  }

  const generateAllEvents = (appointments) => {
    let collections = []
    let count = 0
    try {
      let allEvents = appointments?.map((obj, i) => {
        // let temp = {
        //   Id: i,
        //   PatientID: obj.data.PatientID,
        //   Subject: obj.current.Patient.label,
        //   StartTime: convertDate(obj.data.StartTime),
        //   EndTime: convertDate(obj.data.EndTime),
        //   VisitReason: obj.data.VisitReason,
        //   IsAllDay: false,
        //   Status: "Scheduled",
        //   Provider: obj?.current?.Provider?.label,
        //   Facility: obj.current.Facility.label,
        //   Room: obj.data.RoomNumber,
        //   AppointmentID: obj.data.Id,
        //   AppointmentName: obj.data.AppointmentName || obj.AppointmentName,
        //   Insurance: "Insurance" || obj.Insurance,
        // }

        let temp = {
          Id: i,
          PatientID: obj?.data?.PatientID || obj?.current?.Patient?.value,
          Subject: obj?.current?.Patient?.label || '',
          StartTime: convertDate(obj.data.StartTime),
          EndTime: convertDate(obj.data.EndTime),
          VisitReason: obj.data.VisitReason,
          IsAllDay: false,
          Status: obj.data.Status || 'Scheduled',
          ProviderName: obj?.current?.Provider?.label,
          Facility: obj.current.Facility.label,
          RoomNumber: obj.data.RoomNumber,
          AppointmentID: obj.data.AppointmentID,
          AppointmentName: obj.data.AppointmentName,
          Insurance: obj.data.Insurance || obj.current.Insurance,
          ScheduleBy: obj.data.ScheduleBy || '',
          isDragged: obj?.data?.isDragged || false,
          // PatientStatus: obj?.data?.PatientStatus || 'NewPatient'
          isInFacility: obj?.data?.isInFacility || false,
          Type: obj?.data?.Type || 'New',
          CreatedDate: obj?.data?.CreatedDate || new Date(),
        }

        return temp
      })

      let filterAppointments = allEvents.filter((item) => item.Status === 'Scheduled' || item.Status === 'Rescheduled')
      setEventWithoutFilter(allEvents)
      setAllEvents(filterAppointments)
    } catch (e) {
      console.log(e)
    }

    // try {
    //   allAppointments.map((obj, i) => {
    //     let templocationType = locations.filter(locationObj => {
    //       if (locationObj.ServiceID == obj.ServiceLocation) {
    //         return locationObj.FacilityType
    //       }
    //     })
    //     let facilityT = facilityData.filter(facilityObj => {

    //       if (facilityObj.TypeName == templocationType[0]?.FacilityType) {
    //         return facilityObj.TypeID
    //       }
    //     })[0]?.TypeID
    //     let providerT = providers.filter(pobj => {

    //       if (obj.ProviderID == pobj.ProviderID) {
    //         return obj
    //       }
    //     })[0]

    //     let providerName = providerT ? providerT["Name"] : ''
    //     let temp = {
    //       Id: i + 1,
    //       Subject: obj.PatientName,
    //       StartTime: convertDate(obj.StartTime),
    //       EndTime: convertDate(obj.EndTime),
    //       TypeID: facilityT,
    //       IsAllDay: false,
    //       Status: obj.Status,
    //       Provider: providerName,
    //       AppointmentID: obj.ID,
    //       AppointmentName: obj.Name,
    //       VisitReason: obj.ReasonID,
    //       Notes: obj.Notes,
    //       Description: obj.Notes,
    //       PatientID: obj.PatientID,
    //       ProviderID: obj.ProviderID,
    //       ServiceID: obj.ServiceLocation,
    //       Location: templocationType[0]?.Name
    //     }

    //     collections.push(temp)
    //   })
    //   console.log("All Events: ", collections)
    //   setAllEvents(collections)
    // } catch (e) { console.log(e) }
  }

  const onEventRendered = (args) => {
    // switch (args.data.Status) {
    //     case 'Scheduled':
    //         args.element.style.backgroundColor = '#7FA900';
    //         break;
    //     case 'Rescheduled':
    //         args.element.style.backgroundColor = '#FF0000';
    //         break;
    //     case 'New':
    //         args.element.style.backgroundColor = '#8e24aa';
    //         break;

    // }
    if (args.data.Type === 'New' || args.data.ScheduleBy === 'Edited') {
      args.element.style.backgroundColor = '#7FA900'
    }
    if (args.data.ScheduleBy === 'auto') {
      args.element.style.backgroundColor = '#ffeb3b '
    }
    if (args.data.Type === 'Follow Up' || args.data.ScheduleBy === 'auto-manuel') {
      args.element.style.backgroundColor = '#FFA500'
    }
    if (args.data.Type === 'Re Admit') {
      args.element.style.backgroundColor = '#0000FF'
    }

    // if (args.data.isDragged) {
    //     args.element.style.backgroundColor = 'red';
    // }
    if (args.data.Status === 'Rescheduled') {
      args.element.style.backgroundColor = '#FF0000'
    }
  }

  const onActionBegin = async (args) => {
    if (args.requestType === 'eventCreate' || args.requestType === 'eventChange') {
      const filterAppointment = appointments.filter((item) => item.data.AppointmentID === args.data.AppointmentID)
      const priorAuth = allData?.current?.otherDetails?.priorAuth?.isRequired || false
      const isInFacility = allData?.current?.isInFacility || false
      const patientName = allData?.current?.Patient?.label || ''

      if (!isInFacility) {
        alert(`Patient ${patientName} is not in the facility and cannot be scheduled.`)
        args.cancel = true
        return
      }

      // if (!priorAuth) {
      //     alert(`Patient ${patientName} has no prior authorization and cannot be scheduled.`);
      //     args.cancel = true;
      //     return;

      // }
      if (priorAuth) {
        let noOfTimes = parseInt(allData?.current?.otherDetails?.priorAuth?.details?.noOfTimes, 10)

        if (isNaN(noOfTimes) || noOfTimes <= 0) {
          alert(`Patient  ${patientName || ''}has no remaining insurance and cannot be scheduled.`)
          // if (oldData?.data) {
          //     oldData.data.isInFacility = false;
          // }
          return
        }
      }

      if (args.requestType === 'eventCreate') {
        // let patientID = allData.current.Patient.value.toString()
        // let providerID = allData.current.Provider.value.toString()
        let patientStatus = notSchedule.filter((item) => item.PatientID === allData?.current?.Patient?.value)

        let filtered = allAppointment.filter((entry) => entry.patientID === allData?.current?.Patient?.value && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Finish'))

        let data = args.data[0]

        data['StartTime'] = formatDate(data['StartTime'])
        data['EndTime'] = data['StartTime'].replace(':00', ':15').replace(':30', ':45')
        ;(data['VisitReason'] = filtered.length > 0 ? 'F/U (Follow Up)' : 'N/P (New Patient)'),
          (data = {
            ...data,
            AppointmentID: Date.now(),
            Insurance: allData.current.Insurance || {},
            Facility: allData.current.Facility.label || '',
            Status: 'Scheduled',
            otherDetails: allData.current.otherDetails || {},
            ProviderName: allData.current.Provider.label || '',
            PatientID: allData.current.Patient.value,
            ScheduleBy: 'event',
            // PatientStatus: filtered.length > 0 ? 'Follow Up' : patientStatus.length > 0 ? patientStatus[0]?.Status : 'NewPatient',
            Type: filtered.length > 0 ? 'Follow Up' : 'New',
            CreatedDate: new Date(),
          })

        let details = {
          data,
          ...allData,
        }
        // if (appointment) {
        //   appointment.push(details)
        // } else {
        //   appointment = []
        // }
        setAppointments((prev) => {
          let newAppointments = [...prev, details]
          handleSubmit(newAppointments)
          return newAppointments
        })

        // localStorage.setItem("Appointments", JSON.stringify(appointment))

        // setTimeout(() => handleSubmit(), 1000)
        let providerName = ''
        let serviceName = ''
        // let response = await ModifyAppointment("Create", {
        //   appointmentName: allData["AppointmentName"], serviceID: allData["SelectedLocation"], patientID,
        //   providerID: allData["SelectedProvider"], reasonID: allData["VisitReason"], startTime, endTime, notes: allData["Notes"]
        // })
        // let response = await ModifyAppointment("Create", {
        //   appointmentName: data.AppointmentName, serviceID: '79', patientID,
        //   providerID: providerID, reasonID: data.VisitReason, startTime: data.StartTime, endTime: data.EndTime, notes: data.Notes
        // })
        //window.location.reload()
        // console.log("data1", response)
        // let data1 = JSON.parse(response.d)
        // console.log("data2", data1)
        // generateAllEvents(facilityData, providers, locations, data1.Data)
        // getData()
      } else {
        for (let i = 0; i < args.changedRecords.length; i++) {
          let allChangedData = args.changedRecords[i]

          let oldSchedulingData = appointments.filter((item) => item.data.AppointmentID === allChangedData.AppointmentID)

          let current = {
            Facility: allData.current.Facility || oldSchedulingData[0].current.Facility,
            Insurance: allData?.data?.Insurance || allData.current.Insurance || oldSchedulingData[0].current.Insurance,
            Provider: allData.current.Provider || oldSchedulingData[0].current.Provider,
            Patient: allData.current.Patient || oldSchedulingData[0].current.Patient,
            otherDetails: allData.current.otherDetails || allData.current.otherDetails || oldSchedulingData[0].current.otherDetails,
          }

          let data = {
            ...allChangedData,
            Insurance: current.Insurance,
            Facility: current.Facility.label,
            otherDetails: current.otherDetails,
            ProviderName: current.Provider.label,
            PatientID: current.Patient.value,
            StartTime: formatDate(allChangedData.StartTime) || oldSchedulingData[0]?.data.StartTime || allChangedData.StartTime,
            EndTime: formatDate(allChangedData.StartTime).replace(':00', ':15').replace(':30', ':45') || oldSchedulingData[0]?.data.EndTime || allChangedData.EndTime,
            ScheduleBy: allChangedData?.ScheduleBy === 'auto' ? 'Edited' : allChangedData?.ScheduleBy,
            isInFacility: allData.current.isInFacility || oldSchedulingData[0]?.data.isInFacility || false,
          }

          let FinalData = { data, current }
          setAppointments((appointments) => {
            const updatedAppointments = appointments.some((appointment) => appointment.data.AppointmentID === allChangedData.AppointmentID) ? appointments.map((appointment) => (appointment.data.AppointmentID === allChangedData.AppointmentID ? { data, current } : appointment)) : appointments
            handleSubmit(updatedAppointments)
            return updatedAppointments
          })

          // Call handleSubmit separately after the state update

          //  let startTime =formatDate(allData["StartTime"])
          //  let endTime =formatDate(allData["StartTime"]).replace(":00",":15").replace(":30",":45")
          let location = allData['SelectedLocation'] ? allData['SelectedLocation'] : allData.ServiceID
          let providerID = allData['SelectedProvider'] ? allData['SelectedProvider'] : allData.ProviderID
          let patientID = allData['PatientID']
          // let response =  await ModifyAppointment("Update",{appointmentID:allData["AppointmentID"],appointmentName:allData["AppointmentName"],serviceID:location,patientID,
          //  providerID,reasonID:allData["VisitReason"],startTime,endTime,notes:allData["Notes"],status:""})

          // Instead of MAP use first find.
          // tempAllEvents.map(obj=> {
          //   if(obj.AppointmentID ==allData.AppointmentID ) {
          //       obj.AppointmentName = allData.AppointmentName
          //       obj.StartTime = allData.StartTime
          //       obj.EndTime = allData.EndTime
          //       obj.Status = allData.AppointmentName
          //       obj.AppointmentName = allData.AppointmentName
          //       obj.AppointmentName = allData.AppointmentName
          //   }
          // })
        }
      }
    } else if (args.requestType === 'eventRemove') {
      try {
        let appointment = appointments.filter((item) => item.data.AppointmentID !== args.data[0].AppointmentID)
        // localStorage.setItem("Appointments", JSON.stringify(appointment))
        handleSubmit(appointment)
        // getData()
      } catch (e) {
        console.error('Error', e)
      }
    }
  }

  const btnClick = () => {
    let settingsPanel = document.querySelector('.overview-content .right-panel')
    if (settingsPanel.classList.contains('hide')) {
      removeClass([settingsPanel], 'hide')
      // workWeekObj.current.refresh();
      // resourceObj.current.refresh();
    } else {
      addClass([settingsPanel], 'hide')
    }
    scheduleObj.current.refreshEvents()
  }

  const filterServiceFn = (e) => {
    setFilterService(e)
    filterAppointments(filterProvider, e)
  }

  const filterProviderFn = (e) => {
    setFilterProvider(e)
    filterAppointments(e, filterService)
  }
  const providerFilterTemplate = (e) => {
    return <div className="template"></div>
  }

  const findDates = (allowedWeekdays) => {
    const weekdayMapping = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    }
    const allowedWeekdayNumbers = allowedWeekdays.map((day) => weekdayMapping[day])
    let today = new Date()
    let matchingDates = []

    for (let i = 0; i < 16; i++) {
      let currentDate = new Date(today)
      currentDate.setDate(today.getDate() + i)

      let currentWeekday = currentDate.getDay()

      if (allowedWeekdayNumbers.includes(currentWeekday)) {
        matchingDates.push(currentDate.toString())
      }
    }
    return matchingDates
  }

  const handleTypeFilter = (e, type) => {
    setSelectedFilters((prev) => ({ ...prev, [type]: e }))
    let filter

    if (type === 'status') {
      filter = filterData.filter((item) => item?.Status === e?.value)
    } else if (type === 'provider') {
      filter = filterData.filter((item) => item?.Provider === e?.value)
    } else if (type === 'facility') {
      filter = filterData.filter((item) => item?.FacilityName === e?.label)
    } else if (type === 'date') {
      filter = filterData.filter((item) => item?.Date === e?.value)
    }
    setFilterData(filter)
  }

  const groupTemplate = () => {
    return (
      <div className="template d-flex justify-content-end">
        <div className="icon-child">{/* <CheckBoxComponent id='grouping' checked={false} change={(args) => { scheduleObj.current.group.resources = args.checked ? [] : []; }} /> <span className='text-child'>Grouping</span> */}</div>

        <div>
          {/* <div className="d-flex justify-content-end">
            <div className="d-flex ">
              <CButton color="primary m-1" variant="outline" onClick={() => setVisible(!visible)}>
                Create Appointment
              </CButton>
            </div>
          </div> */}

          <CModal
            size="lg"
            visible={visible}
            backdrop="static"
            onClose={() => {
              setVisible(false), setPatientDate([]), setActiveTab(0), setManual([]), setCheckedPatients([])
            }}
            aria-labelledby="StaticBackdropExampleLabel"
          >
            <CModalHeader>
              <CModalTitle id="StaticBackdropExampleLabel">Create Appointment</CModalTitle>
            </CModalHeader>

            <CModalBody>
              <div className="container mt-3">
                <div className=" ">
                  {activeTab == 0 && (
                    <div>
                      <AutoScheduling
                        notSchedule={notSchedule}
                        setCheckedPatients={setCheckedPatients}
                        setVisible={setVisible}
                        setPatientDate={setPatientDate}
                        setActiveTab={setActiveTab}
                        setManual={setManual}
                        setLoader={setLoader}
                        handleAutoSchedule={handleAutoSchedule}
                        checkedPatients={checkedPatients}
                        // withoutFilterData={notSchedule}
                        setFilterData={setFilterData}
                        setSelectedFilters={setSelectedFilters}
                        providers={providers}
                        facilities={facilities}
                      />
                    </div>
                  )}

                  {activeTab === 1 && (
                    <div>
                      <ManualScheduling
                        providers={providers}
                        notSchedule={filterData}
                        checkedPatients={checkedPatients}
                        locations={locations}
                        findDates={findDates}
                        daysMap={daysMap}
                        setManual={setManual}
                        handleManualSchedule={handleManualSchedule}
                        callManual={callManual}
                        Manual={Manual}
                        setVisible={setVisible}
                        setPatientDate={setPatientDate}
                        setActiveTab={setActiveTab}
                        setLoader={setLoader}
                        allData={allData}
                        setCheckedPatients={setCheckedPatients}
                        appointments={appointments}
                      />
                    </div>
                  )}
                </div>
              </div>
            </CModalBody>
            <CModalFooter></CModalFooter>
          </CModal>
        </div>
      </div>
    )
  }

  const ContentTemplate = (props) => {
    return (
      <div className="quick-info-content">
        {props.elementType === 'cell' ? (
          <div className="e-cell-content">
            <div className="content-area mb-2">
              <TextBoxComponent id="title" placeholder="Appointment Name" />
            </div>
            <div className="content-area mb-2">
              <DropDownListComponent id="VisitReason" placeholder="Choose Visit Reason" data-name="VisitReason" className="e-field" style={{ width: '100%' }} dataSource={['NP (New Patient)', 'F/U (Follow Up Visit)']} />
            </div>
            <div className="content-area mb-2">
              <TextBoxComponent id="notes" placeholder="Notes" />
            </div>
          </div>
        ) : (
          <div className="event-content">
            <div className="meeting-type-wrap">
              <b>
                {' '}
                <label>Name Of Patient </label>
              </b>
              :<span>{props.Subject}</span>
            </div>
            <div className="meeting-subject-wrap">
              <b>
                <label>Reason </label>
              </b>
              :<span>{props.VisitReason}</span>
            </div>
            <div className="notes-wrap">
              <b>
                {' '}
                <label>Provider </label>
              </b>
              :<span>{props.ProviderName || ''}</span>
            </div>
            <div className="notes-wrap">
              <b>
                {' '}
                <label>Facility </label>
              </b>
              :<span>{props.Facility}</span>
            </div>
            <div className="notes-wrap">
              <b>
                {' '}
                <label>Room </label>
              </b>
              :<span>{props.RoomNumber || ''}</span>
            </div>
            <div className="notes-wrap">
              <b>
                {' '}
                <label>Insurance </label>
              </b>
              :<span>{props?.Insurance?.Type || ''}</span>
            </div>
            <div className="notes-wrap">
              <b>
                {' '}
                <label>Status </label>
              </b>
              :<span>{props.Status}</span>
            </div>
          </div>
        )}
      </div>
    )
  }

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const allData = useRef({})
  const editorTemplate = (props) => {
    let day = ''
    let dataForEdit = []
    if (props.AppointmentID) {
      dataForEdit = appointments.filter((item) => item.data.AppointmentID === props.AppointmentID) || []
    }

    if (Object.keys(props).length > 0) {
      const startTime = new Date(props.StartTime)
      const endTime = new Date(props.EndTime)
      const date = startTime.toISOString().split('T')[0]
      const dayOptions = { weekday: 'long' }
      day = startTime.toLocaleDateString('en-US', dayOptions)

      try {
        const allDayData = daysMap[day]
        allDayData.map((obj) => {
          obj.Facilities.map((facility) => {
            let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
            facility['Name'] = tempFacility.Name
            facility['Type'] = tempFacility.Type
            return facility
          })
          return obj
        })
        return <AddAppointments appointments={appointments} allDayData={allDayData} allData={allData} props={props} providers={providers} locations={locations} testoptions={testoptions} patientData={patientData} dataForEdit={dataForEdit}></AddAppointments>
      } catch (e) {
        alert('No Data for this day')
      }
    }
  }

  const onEventDragStop = (args) => {
    // console.log("data is dragged-----> ", args, args.data.isDragged)

    const targetDate = args.data.StartTime
    const facilityName = args.data.Facility
    const providerName = args.data.ProviderName
    const providerData = providers.find((item) => item.Name === providerName)
    let filter = locations.filter((item) => item.Name === facilityName)

    let allowDays = filter.map((item) => item.Days)
    allowDays = allowDays[0].split(',')

    if (!isDateAllowed(targetDate, allowDays, args)) {
      args.cancel = true
      const dayName = targetDate.toLocaleDateString('en-US', { weekday: 'long' })
      alert(` ${providerName} is not available on ${dayName}.`)
      return
    }

    if (!args.data.isDragged) {
      args.data.isDragged = true
      // args.element.style.backgroundColor = 'red';
      args.data.Status = 'Rescheduled'
    } else {
      args.cancel = true
      alert(`Patient is Already Rescheduled`)
    }
  }

  const isDateAllowed = (date, allowedDays, args) => {
    const dayName = date.toLocaleDateString('en-US', { weekday: 'long' })
    return allowedDays.includes(dayName)
  }

  const handleSchedule = (props, patient, oldData) => {
    let day = ''
    let startTime = new Date(props.StartTime)
    let endTime = new Date(props.EndTime)
    const incrementDay = (currentDate) => {
      const nextDate = new Date(currentDate)
      nextDate.setDate(nextDate.getDate() + 1) // Increment day by 1
      return nextDate
    }
    let counter = 0
    while (Object.keys(props).length > 0) {
      const date = startTime.toISOString().split('T')[0]

      const dayOptions = { weekday: 'long' }
      day = startTime.toLocaleDateString('en-US', dayOptions)

      try {
        const allDayData = daysMap[day]
        if (!allDayData) {
          console.warn(`No data found for ${day}. Moving to the next day.`)
          startTime = incrementDay(startTime)
          continue // Skip the rest of the logic and retry for the next day
        }

        allDayData.map((obj) => {
          obj.Facilities.map((facility) => {
            let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
            facility['Name'] = tempFacility.Name
            facility['Type'] = tempFacility.Type
            return facility
          })
          return obj
        })

        const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

        if (providerInfo.length === 0) {
          console.warn(`No data for ${day}. Moving to the next day.`)
          startTime = incrementDay(startTime)
        } else {
          // allData.current.Provider = {
          //     value: providerInfo[0].ID,
          //     label: providerInfo[0].Name,
          // };

          let provider = providerInfo.filter((item) => item?.ID === oldData?.current?.Provider?.value)

          if (provider.length === 0) {
            provider = providerInfo[0]
          } else {
            provider = provider[0]
          }
          allData.current.Provider = {
            value: provider?.ID,
            label: provider?.Name,
          }
          return startTime
        }
        counter++
        if (counter > 7) {
          alert(`No providers are currently assigned to this facility for patient ${props?.PatientName || ''}. Scheduling cannot proceed at this time.`)
          break
        }
      } catch (e) {
        console.error('Error processing schedule:', e)
      }
    }
  }

  const handleAutoSchedule = async (checkedPatientsList) => {
    let notScheduleList = checkedPatientsList.length > 0 ? notSchedule.filter((notSchedule) => checkedPatientsList.includes(parseInt(notSchedule.PatientID))) : notSchedule

    const tempAppointments = []

    await Promise.all(
      notScheduleList.map(async (item) => {
        let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
        let Insurance = {}
        try {
          patientInsurance = JSON.parse(patientInsurance.d)?.Data
          if (patientInsurance.length > 0) {
            Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
            Insurance = Insurance[0] || {}
          }
        } catch (e) {}
        try {
          let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
          getPatientTime = JSON.parse(getPatientTime.d)?.Data
          getPatientTime = getPatientTime.map((entry) => ({
            ...entry,
            getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
          }))
          if (getPatientTime) {
            let rawDate = getPatientTime.length > 0 ? getPatientTime[getPatientTime?.length - 1].date : new Date().toISOString().split('T')[0]

            let formattedDate = rawDate.replaceAll('.', '/')

            let props = {
              StartTime: formattedDate,
              EndTime: formattedDate,
              PatientID: item.PatientID,
              PatientName: item.FirstName,
            }

            let filtered = allAppointment.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Finish'))
            let oldData
            if (filtered.length > 0) {
              oldData = filtered[0].appointmentDetails.at(-1)
            }

            let updateOtherDetails = {}

            const priorAuth = oldData?.data?.otherDetails?.priorAuth

            // if (priorAuth?.isRequired) {
            //     let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10);

            //     if (isNaN(noOfTimes) || noOfTimes <= 0) {
            //         alert(
            //             `Patient ${item.FirstName} ${item.LastName || ""} has no remaining insurance and cannot be scheduled.`
            //         );
            //         if (oldData?.data) {
            //             oldData.data.isInFacility = false;
            //         }
            //         // return;
            //     }
            // }

            let scheduledDate = await handleSchedule(props, item, oldData)
            let organizeDate = formatDate(scheduledDate)

            let facility = locations?.find((facility) => facility.Name === item.FacilityName)

            let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
            let localFacility = { value: facility?.ID, label: facility?.Name }
            let localProvider = allData.current?.Provider || {}

            let data = {
              AppointmentName: `${item.FirstName} ${item.LastName}`,
              StartTime: organizeDate,
              EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
              PatientID: item.PatientID,
              StartTimezone: null,
              EndTimezone: null,
              Insurance: Insurance || {},
              Status: 'Scheduled',
              Notes: '',
              RoomNumber: item.Room,
              RecurrenceRule: '',
              VisitReason: filtered.length > 0 ? 'F/U (Follow Up)' : item?.patient?.Status == 'Follow Up' ? 'F/U (Follow Up)' : 'N/P (New Patient)',
              isInFacility: oldData ? oldData?.data?.isInFacility || false : false,
              otherDetails: oldData ? oldData?.data?.otherDetails || {} : {},
              AppointmentID: Date.now(),
              ProviderName: localProvider?.label || '',
              ScheduleBy: 'auto',
              // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
              // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
              Type: filtered.length > 0 ? 'Follow Up' : item?.patient?.Status == 'Follow Up' ? 'Follow Up' : 'New',
              CreatedDate: new Date(),
            }

            let details = {
              data,
              current: {
                Patient: localPatient,
                Facility: localFacility,
                Provider: localProvider,
                Insurance: Insurance,
              },
            }

            tempAppointments.push(details)

            setPatientDate((prev) => [...prev, { patientID: item.PatientID, date: formattedDate }])
          } else {
            alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
          }
        } catch (error) {
          console.error('Error fetching patient orders', error)
        }
      }),
    )

    // Update appointments once at the end
    if (tempAppointments.length > 0) {
      setAppointments((prev) => {
        const allAppointments = [...prev, ...tempAppointments]
        handleSubmit(allAppointments)
        return allAppointments
      })
    }

    setCheckedPatients([])
    // getData();
    setVisible(false)
  }

  const handleManualSchedule = async () => {
    let notScheduleList

    if (checkedPatients.length > 0) {
      notScheduleList = notSchedule.filter((notSchedule) => checkedPatients.includes(parseInt(notSchedule.PatientID)))
    } else {
      notScheduleList = notSchedule
    }

    const tempAppointments = []

    await Promise.all(
      notScheduleList.map(async (item, index) => {
        const isFacility = Manual[index]?.isFacility || false
        // const insurance  =  Manual[index]?.Insurance || null;
        // console.log("insuranse data ", insurance)

        // if(!insurance){
        //     alert(
        //         `Patient ${item?.FirstName} ${item?.LastName || ""} has no insurance.`
        //     );
        //     return;
        // }

        if (!isFacility) {
          alert(`Patient ${item?.FirstName} ${item?.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        const priorAuth = Manual[index]?.otherDetails?.priorAuth?.isRequired || false
        // if (!priorAuth) {
        //     alert(`Patient ${item?.FirstName} ${item?.LastName || ""}  has no prior authorization and cannot be scheduled.`);
        //     // args.cancel = true;
        //     return;

        // }
        if (priorAuth) {
          let noOfTimes = parseInt(Manual[index]?.otherDetails?.priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item?.FirstName} ${item?.LastName || ''} has no prior insurance left and cannot be scheduled.`)
            // if (oldData?.data) {
            //     oldData.data.isInFacility = false;
            // }
            return
          }
        }

        let filtered = allAppointment.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Finish'))
        let oldData
        if (filtered.length > 0) {
          oldData = filtered[0].appointmentDetails.at(-1)
        }

        let time = Manual?.find((itemPatient) => itemPatient.patient.PatientID == item.PatientID)?.selectedDate

        try {
          let props = {
            StartTime: formatDate(time),
            EndTime: formatDate(time),
            PatientID: item.PatientID,
          }

          let date = handleSchedule(props, item, oldData)
          let organizeDate = formatDate(date)
          let facility = locations?.find((fac) => fac.Name === item.FacilityName)

          let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
          let localFacility = { value: facility?.ID || '', label: facility?.Name || '' }
          let localProvider =
            {
              value: Manual[index]?.selectedProvider?.value,
              label: Manual[index]?.selectedProvider?.label,
            } ||
            allData.current.Provider ||
            {}

          // let Insurance = {};
          // let insuranceData = item?.Insurance[0]?.InsuranceDetails;
          // console.log(" insurance details data , ", insuranceData, item)

          // if (insuranceData?.length > 0) {
          //     try {
          //         Insurance = JSON.parse(insuranceData)[0] || {};
          //     } catch (e) {
          //         Insurance = Manual[index]?.Insurance || {};
          //     }
          // } else {
          //     Insurance = Manual[index]?.Insurance || {};
          // }
          let Insurance = Manual[index]?.Insurance || {}

          let data = {
            AppointmentName: `${item.FirstName} ${item.LastName}`,
            StartTime: organizeDate,
            EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
            PatientID: item.PatientID,
            StartTimezone: null,
            EndTimezone: null,
            Status: 'Scheduled',
            Notes: '',
            RoomNumber: item.Room,
            VisitReason: filtered.length > 0 ? 'F/U (Follow Up)' : item?.patient?.Status == 'Follow Up' ? 'F/U (Follow Up)' : 'N/P (New Patient)',
            Insurance: Insurance,
            // isInFacility: oldData ? (oldData?.data?.isInFacility || false) : Manual[index]?.isFacility,
            // otherDetails: oldData ? (oldData?.data?.otherDetails || {}) : (Manual[index]?.otherDetails || {}),
            isInFacility: Manual[index]?.isFacility || oldData?.data?.isInFacility || false,
            otherDetails: Manual[index]?.otherDetails || oldData?.data?.otherDetails || {},
            Facility: facility?.Name || '',
            ProviderName: localProvider?.label || '',
            AppointmentID: Date.now(),
            ScheduleBy: 'manuel',
            // PatientStatus: filtered.length > 0 ? 'Follow Up' : item?.Status || 'NewPatient'
            Type: filtered.length > 0 ? 'Follow Up' : item?.patient?.Status == 'Follow Up' ? 'Follow Up' : 'New',
            CreatedDate: new Date(),
            // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
          }

          let details = {
            data,
            current: {
              Patient: localPatient,
              Facility: localFacility,
              Provider: localProvider,
            },
          }

          tempAppointments.push(details)
        } catch (error) {
          console.error('Error in scheduling', error)
        }
      }),
    )

    // Update appointments and submit once
    setAppointments((prev) => {
      const allAppointments = [...prev, ...tempAppointments]
      handleSubmit(allAppointments)
      return allAppointments
    })

    setCheckedPatients([])
    //    / getData();
    setVisible(false)
    setActiveTab(0)
    setManual([])
    setCallManual(false)
  }

  const handleManualScheduleData = async (notScheduleList) => {
    let tempAppointments = []
    await Promise.all(
      notScheduleList.map(async (item, index) => {
        const isFacility = item?.isFacility || false
        // const insurance  =  Manual[index]?.Insurance || null;
        // console.log("insuranse data ", insurance)

        // if(!insurance){
        //     alert(
        //         `Patient ${item.patient?.FirstName} ${item.patient?.LastName || ""} has no insurance.`
        //     );
        //     return;
        // }

        if (!isFacility) {
          alert(`Patient ${item.patient?.FirstName} ${item.patient?.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        const priorAuth = item?.otherDetails?.priorAuth?.isRequired || false
        // if (!priorAuth) {
        //     alert(`Patient ${item.patient?.FirstName} ${item.patient?.LastName || ""}  has no prior authorization and cannot be scheduled.`);
        //     // args.cancel = true;
        //     return;

        // }
        if (priorAuth) {
          let noOfTimes = parseInt(item?.otherDetails?.priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.patient?.FirstName} ${item.patient?.LastName || ''} has no prior insurance left and cannot be scheduled.`)
            // if (oldData?.data) {
            //     oldData.data.isInFacility = false;
            // }
            return
          }
        }

        let filtered = allAppointment.filter((entry) => entry.patientID === item.patient.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Finish'))
        let oldData
        if (filtered.length > 0) {
          oldData = filtered[0].appointmentDetails.at(-1)
        }

        let time = item.selectedDate
        try {
          let props = {
            StartTime: formatDate(time),
            EndTime: formatDate(time),
            PatientID: item.patient.PatientID,
          }

          let date = handleSchedule(props, item.patient, oldData)
          let organizeDate = formatDate(date)
          let facility = locations?.find((fac) => fac.Name === item.patient.FacilityName)

          let localPatient = { value: item.patient.PatientID, label: `${item.patient.FirstName} ${item.patient.LastName}` }
          let localFacility = { value: facility?.ID || '', label: facility?.Name || '' }
          let localProvider =
            {
              value: item?.selectedProvider?.value,
              label: item?.selectedProvider?.label,
            } ||
            allData.current.Provider ||
            {}

          // let Insurance = {};
          // let insuranceData = item.patient?.Insurance[0]?.InsuranceDetails;
          // console.log(" insurance details data , ", insuranceData, item.patient)

          // if (insuranceData?.length > 0) {
          //     try {
          //         Insurance = JSON.parse(insuranceData)[0] || {};
          //     } catch (e) {
          //         Insurance = item?.Insurance || {};
          //     }
          // } else {
          //     Insurance = item?.Insurance || {};
          // }
          let Insurance = item?.Insurance || {}

          let data = {
            AppointmentName: `${item.patient.FirstName} ${item.patient.LastName}`,
            StartTime: organizeDate,
            EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
            PatientID: item.patient.PatientID,
            StartTimezone: null,
            EndTimezone: null,
            Status: 'Scheduled',
            Notes: '',
            RoomNumber: item.patient.Room,
            VisitReason: filtered.length > 0 ? 'F/U (Follow Up)' : 'N/P (New Patient)',
            Insurance: Insurance,
            // isInFacility: oldData ? (oldData?.data?.isInFacility || false) : item?.isFacility,
            // otherDetails: oldData ? (oldData?.data?.otherDetails || {}) : (item?.otherDetails || {}),
            isInFacility: item?.isFacility || oldData?.data?.isInFacility || false,
            otherDetails: item?.otherDetails || oldData?.data?.otherDetails || {},
            Facility: facility?.Name || '',
            ProviderName: localProvider?.label || '',
            AppointmentID: Date.now() + index,
            ScheduleBy: 'manuel',
            // PatientStatus: filtered.length > 0 ? 'Follow Up' : item?.Status || 'NewPatient'
            Type: filtered.length > 0 ? 'Follow Up' : 'New',
            CreatedDate: new Date(),
            // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
          }

          let details = {
            data,
            current: {
              Patient: localPatient,
              Facility: localFacility,
              Provider: localProvider,
            },
          }

          tempAppointments.push(details)
        } catch (error) {
          console.error('Error in scheduling', error)
        }
      }),
    )

    // Update appointments and submit once
    setAppointments((prev) => {
      const allAppointments = [...prev, ...tempAppointments]
      handleSubmit(allAppointments)
      return allAppointments
    })

    setCheckedPatients([])
    //    / getData();
    setVisible(false)
    setActiveTab(0)
    setManual([])
    setCallManual(false)
  }

  return (
    <>
      <LoadingOverlay active={loader} spinner text="Loading Events">
        <div className="schedule-control-section ">
          <div className="col-lg-12 control-section">
            <div className="control-wrapper">
              <AppBarComponent colorMode="Primary">
                <span className="time e-icons e-time-zone"></span>
                <span id="timezoneBtn" className="time ">
                  UTC
                </span>
                <span className="time e-icons e-clock"></span>
                <span id="timeBtn" className="time current-time" ref={timeBtn}></span>
                <div className="e-appbar-spacer"></div>
                {/* <div className='control-panel calendar-export'>
                    <ButtonComponent id='printBtn' cssClass='title-bar-btn e-inherit' iconCss='e-icons e-print'  content='Print'/>
                  </div> */}
                {/* <div className='control-panel import-button'>
                    <UploaderComponent id='fileUpload' type='file' allowedExtensions='.ics' cssClass='calendar-import' buttons={{ browse: importTemplateFn({ text: 'Import' })[0] }} multiple={false} showFileList={false} selected={(onImportClick)} created={createUpload}/>
                  </div> */}
                <div className="control-panel "></div>
                <ButtonComponent id="settingsBtn" cssClass="overview-toolbar-settings e-inherit" iconCss="e-icons e-settings" iconPosition="Top" content="" onClick={btnClick} />
              </AppBarComponent>
              <ToolbarComponent id="toolbarOptions" cssClass="overview-toolbar" overflowMode="Scrollable" scrollStep={100} style={{ visibility: false }}>
                <ItemsDirective>
                  {/* <ItemDirective prefixIcon='e-icons e-plus' tooltipText='New Appointment' text='New Appointment' tabIndex={0} /> */}
                  <ItemDirective type="Separator" />

                  {/* <ItemDirective prefixIcon='e-icons e-week' tooltipText='Week' text='Week' tabIndex={0}/>
                    
                    <ItemDirective prefixIcon='e-icons e-month' tooltipText='Month' text='Month' tabIndex={0}/>
                    <ItemDirective prefixIcon='e-icons e-agenda-date-range' tooltipText='Agenda' text='Agenda' tabIndex={0}/>
                   */}

                  <ItemDirective tooltipText="Grouping" text="Grouping" template={groupTemplate} />
                  <ItemDirective type="Seperator"></ItemDirective>
                  <ItemDirective tooltipText="" text="" template={providerFilterTemplate}></ItemDirective>
                </ItemsDirective>
              </ToolbarComponent>
              <div className="overview-content">
                <div className="left-panel">
                  <ScheduleComponent
                    cssClass="virtual-scrolling"
                    width="100%"
                    height="650px"
                    selectedDate={new Date()}
                    eventSettings={{
                      dataSource: allEvents,
                      enableTooltip: true,
                    }}
                    allowMultiDrag={true}
                    group={{ resources: ['Type'] }}
                    ref={scheduleObj}
                    quickInfoTemplates={{ content: ContentTemplate.bind(this) }}
                    editorTemplate={editorTemplate}
                    actionBegin={onActionBegin}
                    showQuickInfo={true}
                    eventRendered={onEventRendered}
                    dragStop={onEventDragStop}
                  >
                    <ViewsDirective>
                      <ViewDirective option="Month" isSelected={true} />
                      <ViewDirective option="Week" />
                      <ViewDirective option="Agenda" />
                    </ViewsDirective>
                    <ResourcesDirective>
                      <ResourceDirective field="TypeID" title="Facility" name="Type" allowMultiple={true} dataSource={facilityData} textField="TypeName" idField="TypeID" colorField="Color"></ResourceDirective>
                    </ResourcesDirective>
                    <Inject services={[Month, Week, Agenda, Resize, DragAndDrop]} />
                  </ScheduleComponent>
                </div>
                <div className="right-panel p-3 bg-light shadow rounded  hide">
                  <div className="control-panel e-css">
                    <h5 className="text-secondary border-bottom pb-2 mb-3">Filters</h5>

                    {/* Provider Filter */}
                    <div className="mb-4">
                      <h6 className="text-dark">Provider Filter</h6>
                      <div className="col-row mb-2">
                        <div style={{ width: '15rem' }}>
                          <Select classNamePrefix="react-select" value={filterProvider} onChange={filterProviderFn} options={[{ value: 0, label: 'All-Providers' }, ...providers.map((item) => ({ value: item.ID, label: item.Name }))]} placeholder="Select Provider" />
                        </div>
                      </div>
                    </div>

                    {/* Location Filter */}
                    <div>
                      <h6 className="text-dark">Facility Filter</h6>
                      <div className="col-row" style={{ width: '15rem' }}>
                        <Select classNamePrefix="react-select" value={filterService} onChange={filterServiceFn} options={locations.map((obj) => ({ value: obj.ID, label: obj.Name }))} placeholder="Select Location" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  )
}

export default SchedulereMulti
